<template>
  <GoogleLogin
      :onFailure="onFailure"
      :onSuccess="onSuccess"
      :params="params"
      class="login-google d-flex flex-row justify-start pa-2"
  >
    <span>
      <v-img :src="google" class="social-img"/>
    </span>
    <span class="ml-2 text-capitalize">
      Sign in with Google
    </span>
  </GoogleLogin>
</template>

<script>
import GoogleLogin from 'vue-google-login';
import {VUE_GOOGLE_CLIENT_ID} from "@/config/"
import google from "@/assets/google.png";
import {mapMutations} from "vuex";

export default {
  name: "GoogleSignInButton",
  components: {
    GoogleLogin
  },
  data() {
    return {
      google,
      loading: false,
      params: {
        client_id: VUE_GOOGLE_CLIENT_ID
      },
      routeOnLogin: "/home",
    }
  },
  methods: {
    ...mapMutations({
      SET_AUTH_SUCCESS: "auth/SET_AUTH_SUCCESS",
      SET_USER_PROFILE: "auth/SET_USER_PROFILE",
      SET_AUTH_DIALOG: "auth/SET_AUTH_DIALOG"
    }),
    async onSuccess(googleUser) {
      this.loading = true;
      const postData = {
        auth_token: googleUser.getAuthResponse().id_token
      }
      const {data} = await this.axios.post('google/', postData);
      const user = data.data
      this.SET_AUTH_SUCCESS(user);
      this.SET_USER_PROFILE(user.profile);
      localStorage.setItem("access_token", user.tokens.access);
      localStorage.setItem("refresh_token", user.tokens.refresh);
      this.$analytics.logEvent("user_sign_in", {
        user: user,
        time: new Date(),
        url: window.location.href,
        version: "frontend version"
      });

      // If the login action was from the sign in modal dialog
      this.SET_AUTH_DIALOG(false)

      if (!user.is_existing || !user.account_types.length) await this.$router.push("/on-boarding");
      else {
        const from = this.$router.history.current.query?.from
        if (from === '/forgot_password' || from === '/signup' || from === '/on-boarding') {
          await this.$router.push(this.routeOnLogin);
        }
        else await this.$router.push(from ? from : this.routeOnLogin);
      }
    },

    onFailure(error) {
      this.loading = false;
      localStorage.removeItem("access_token")
      localStorage.removeItem("refresh_token")
      this.$snackbar.showMessage({
        content: this.constructSignInErrorMessage(error) || this.$t('errors.somethingWentWrongError'),
        color: "error",
      });
    },
    constructSignInErrorMessage(error) {
      if(error?.response?.data?.data?.detail) return error?.response?.data?.data?.detail
      if (error.error) return error.error.replace(/_/g, ' ')
      let errorMessage = '';
      const errorData = error.response?.data || ''
      if (errorData) {
        if (errorData.detail) {
          errorMessage = errorData.detail
        } else if (errorData.data?.non_field_errors) {
          const errors = errorData.data.non_field_errors
          if (errors.length === 1) return errorMessage = errors[0]
          errors.forEach((msg, index) => {
            if (index === errors.length - 1) {
              errorMessage += msg
            }
            errorMessage += msg + ', '
          })
        }
      }
      return errorMessage
    }
  }
}
</script>

<style scoped>
.login-google {
  background: #f5f6f8 !important;
  color: rgba(66, 66, 66, 0.6) !important;
  border-radius: .3em;
}

.social-img {
  width: 20px;
  height: 80%;
}

</style>
